import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ElderPaneSubtitleComponent } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { ConfigurationBrowserComponent } from '../../../capability-spec/constraints/configurations/configuration-browser/configuration-browser.component'
import { ScrapRule } from '../scrap-rule'

@Component({
  selector: 'app-scrap-rule-detail',
  templateUrl: './scrap-rule-detail.component.html',
  styleUrls: ['./scrap-rule-detail.component.scss'],
  imports: [
    ElderPaneSubtitleComponent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ConfigurationBrowserComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ScrapRuleDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly scrapRule$ = new BehaviorSubject<ScrapRule>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set scrapRule(rule: ScrapRule) {
    this.scrapRule$.next(rule)
  }

  public get scrapRule(): ScrapRule {
    return this.scrapRule$.getValue()
  }
}
